import React from 'react';
import styled from '@emotion/styled';
import { useTranslation } from 'react-i18next';
import Card from '@app/components/card/Card';
import SVG from '@app/components/SVG';
import ErrorSVG from '@supplierRegistration/images/icon-page-error.svg';
import { BodyRegularStartTransparentBlack900 } from '@app/components/Text';

export const InactiveLinkError: React.FC = () => {
  const { t } = useTranslation();
  return (
    <ErrorContainer>
      <ErrorMainCard>
        <StyledSVG image={ErrorSVG} accessibilityLabel='error' />
        <span>
          <strong>{t('supplierValidation.supplierRegister.errors.inactiveLinkTitle')}</strong>{' '}
          {t('supplierValidation.supplierRegister.errors.inactiveLinkBody')}
        </span>
      </ErrorMainCard>
    </ErrorContainer>
  );
};

const ErrorContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const ErrorMainCard = styled(Card)`
  display: flex;
  flex-direction: column;
  text-align: center;
  align-items: center;
  ${BodyRegularStartTransparentBlack900.css};
  padding: 30px clamp(20px, 5vw, 50px) 30px;
  max-width: 500px;
`;

const StyledSVG = styled(SVG)`
  width: 70px;
  height: 70px;
  margin-bottom: 5px;
`;
